import { Loader } from 'semantic-ui-react';

export default function ApplicationLoader({ text = 'Loading...' }) {
  return (
    <div className="user-loader">
      <Loader active inline content={text} />
    </div>
  );
}
